export const GET_NOTICES = "GET_NOTICES";
export const GET_PROSPECTS = "GET_PROSPECTS";